import React from "react";
import * as SC from "./PrintPostEditorReddit.styled.js";

import { channelsByShortName } from "../../../../../../data/app__channels";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor.jsx";
import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor.jsx";
import { useTranslation } from "react-i18next";

//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const PrintPostEditorReddit = ({
  postData,
  channel,
  channelData,
  mobile,
  editable,
  selectedCreativeIndexToEdit,
  mediaAssetsProps,
  mediaAssets
}) => {
  const { t } = useTranslation();
  const templatePreviewSizes = {
    minHeight: SC.REDDIT_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].minHeight,
    maxHeight: SC.REDDIT_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].maxHeight,
    width: SC.REDDIT_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth,
    minAspect: channelsByShortName.reddit.minAspect,
    maxAspect: channelsByShortName.reddit.maxAspect
  };

  return (
    <SC.PostEditorWrapper mobile={mobile}>
      <SC.BodyWrapper>
        <SC.Header>
          <SC.Avatar alt="Reddit Page Name" src="/images/icon__reddit-preview.png" />
          <SC.UserInfo>
            <SC.Promoted>JobHappier</SC.Promoted>
            <SC.Sponsored>{t("Sponsored")}</SC.Sponsored>
          </SC.UserInfo>
        </SC.Header>
        <SC.EditorWrapper>
          <PrintCampaignCreateTeaserEditor
            channel="reddit"
            teaserText={postData.teaserText}
            editable={editable}
            teaserTextStyle={SC.teaserTextStyle}
            limit={channelsByShortName.reddit.limits.teaserText}
            minRows={3}
            isAutoGenerated={postData?.isAutoGenerated}
            autoGeneratedText={postData?.autoGeneratedText}
            isEdited={postData?.editedStates?.teaserText}
          />
        </SC.EditorWrapper>
        <PrintTemplateEditor
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          mediaAssets={mediaAssets}
          mediaAssetsProps={mediaAssetsProps}
          templateType="image"
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          logos={postData.logos || postData.creatives.map(() => "")}
          templatePreviewSizes={templatePreviewSizes}
          channel={channel}
        />
        <SC.BarCTA>
          <PrintCampaignCreateChannelDataEditor
            value={channelData.displayLink}
            dataKey="displayLink"
            textStyle={SC.displayLinkStyle}
            limit={channelsByShortName.reddit.limits.displayLink}
            label={t("Displayed link")}
            tooltip={t("Displayed link")}
            editable={editable}
            urlValue={channelData.url}
          />
          <SC.BarCTABtn>
            <a href={channelData.url} target="_blank" style={{ color: "#24a0ed" }} rel="noreferrer">
              Bewerben
            </a>
          </SC.BarCTABtn>
        </SC.BarCTA>
        <SC.Bar src="/images/reddit-bar.png"></SC.Bar>
      </SC.BodyWrapper>
    </SC.PostEditorWrapper>
  );
};

export default PrintPostEditorReddit;
